import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  fetchDealerReportContext,
  submitDealerReport,
} from "../../services/automapTrustSafetyApi";
import {
  DEALER_REPORT_CATEGORIES,
  REPORT_SUCCESS_COPY,
  SAFETY_DISCLAIMER,
  trackTrustSafetyEvent,
} from "../../constants/automapTrustSafetyConstants";

export default function ReportDealerPage() {
  const { dealerId } = useParams();
  const [context, setContext] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [form, setForm] = useState({
    category: "dealer_no_response",
    description: "",
    buyerName: "",
    buyerWhatsapp: "",
    buyerEmail: "",
    relatedListingId: "",
    evidenceUrl: "",
    consent: false,
  });

  useEffect(() => {
    trackTrustSafetyEvent("trust_report_dealer_opened", { dealerId });
    fetchDealerReportContext(dealerId)
      .then(setContext)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [dealerId]);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.consent) {
      setError("Debe aceptar el consentimiento.");
      return;
    }
    setError("");
    try {
      await submitDealerReport(dealerId, {
        category: form.category,
        description: form.description,
        buyerName: form.buyerName || null,
        buyerWhatsapp: form.buyerWhatsapp || null,
        buyerEmail: form.buyerEmail || null,
        listingId: form.relatedListingId || null,
        evidenceUrls: form.evidenceUrl ? [form.evidenceUrl] : [],
        sourceComponent: "report_dealer_page",
      });
      trackTrustSafetyEvent("trust_report_submitted", { dealerId, category: form.category });
      setSubmitted(true);
    } catch (err) {
      setError(err.message || "No se pudo enviar el reporte.");
    }
  };

  if (loading) return <main className="wrap" style={{ padding: "2rem" }}><p>Cargando…</p></main>;
  if (error && !context) return <main className="wrap" style={{ padding: "2rem" }}><p>{error}</p></main>;

  if (submitted) {
    return (
      <main className="wrap" style={{ padding: "2rem", maxWidth: 640 }}>
        <h1>Gracias</h1>
        <p>{REPORT_SUCCESS_COPY}</p>
        <Link to="/seguridad">Ver guía de compra segura</Link>
      </main>
    );
  }

  const dealer = context?.dealer;
  return (
    <main className="wrap" style={{ padding: "2rem", maxWidth: 640 }}>
      <h1>Reportar problema con este concesionario</h1>
      <p>Ayúdanos a mantener AutoMapa confiable. Revisaremos tu reporte y tomaremos acción si encontramos información incorrecta o riesgosa.</p>
      {dealer ? <p><strong>{dealer.businessName}</strong>{dealer.city ? ` · ${dealer.city}` : ""}</p> : null}
      <form onSubmit={submit} className="dealer-form-grid" style={{ marginTop: "1rem" }}>
        <label>
          Categoría
          <select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}>
            {DEALER_REPORT_CATEGORIES.map((c) => (
              <option key={c.value} value={c.value}>{c.label}</option>
            ))}
          </select>
        </label>
        <label className="full">
          Descripción *
          <textarea required value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} rows={4} />
        </label>
        <label>Nombre (opcional)<input value={form.buyerName} onChange={(e) => setForm({ ...form, buyerName: e.target.value })} /></label>
        <label>WhatsApp (opcional)<input value={form.buyerWhatsapp} onChange={(e) => setForm({ ...form, buyerWhatsapp: e.target.value })} /></label>
        <label>Email (opcional)<input value={form.buyerEmail} onChange={(e) => setForm({ ...form, buyerEmail: e.target.value })} /></label>
        <label>Listing relacionado (opcional)<input value={form.relatedListingId} onChange={(e) => setForm({ ...form, relatedListingId: e.target.value })} placeholder="ID del vehículo" /></label>
        <label className="full">URL de evidencia (opcional)<input value={form.evidenceUrl} onChange={(e) => setForm({ ...form, evidenceUrl: e.target.value })} placeholder="https://..." /></label>
        <label className="full">
          <input type="checkbox" checked={form.consent} onChange={(e) => setForm({ ...form, consent: e.target.checked })} />
          {" "}Acepto que AutoMapa revise este reporte y, si es necesario, contacte al concesionario.
        </label>
        {error ? <p className="dealer-state-box">{error}</p> : null}
        <button type="submit" className="admin-btn admin-btn--primary">Enviar reporte</button>
      </form>
      <p className="muted" style={{ marginTop: "1rem" }}>{SAFETY_DISCLAIMER}</p>
    </main>
  );
}
